export const GET_LIST_REQUEST = "AutographDevices/GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "AutographDevices/GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "AutographDevices/GET_LIST_FAILURE";
